import { ReactNode } from 'react';

import { TSvgProps } from '@r1-frontend/ui-react/components/svg/createSvg';
import { Paragraph4, Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as ST from './styled';

export interface IListItemWithIcon {
    Icon: (props: TSvgProps) => JSX.Element,
    title?: string,
    value: string | ReactNode,
    isBiggerFont?: boolean,
}

const ListItemWithIcon = ({
    Icon,
    title = '',
    value,
    isBiggerFont = false,
}: IListItemWithIcon): JSX.Element => {
    return (
        <ST.Wrapper>
            <ST.IconWrapper>
                <Icon size={24}/>
            </ST.IconWrapper>
            <ST.TextWrapper>
                {title && (
                    isBiggerFont
                        ? <Paragraph4 $color={COLORS.TextHint} $smaller>{title}</Paragraph4>
                        : <Paragraph5 $color={COLORS.TextHint}>{title}</Paragraph5>
                )}
                {typeof value === 'string'
                    ? <Paragraph4 $color={COLORS.TextPrimary} $smaller={!isBiggerFont}>{value}</Paragraph4>
                    : value
                }
            </ST.TextWrapper>
        </ST.Wrapper>
    );
};

export default ListItemWithIcon;
